import React from 'react';
import PropTypes from 'prop-types';
import { Paper, Box } from '@mui/material';

import { useTabManagement } from 'src/hooks/useTabManagement';
import PitchInboxTabs from 'src/pages/QueryPages/QueryProfile/components/PitchInboxTabs';
import TabContent from 'src/pages/QueryPages/QueryProfile/components/TabContent';
import QueryNotesTab from 'src/pages/QueryPages/QueryProfile/components/tabs/QueryNotesTab';
import { useDecodedToken } from 'src/hooks/useDecodedToken';
import { useExpertManagement } from 'src/hooks/useExpertManagement';
import { getPitchForExpert } from 'src/utils/queryUtils';

const PitchCard = ({ query, refetch }) => {
  const { isExpert } = useDecodedToken();
  const { activeTab, availableTabs, handleTabChange } = useTabManagement(query, isExpert);
  const { selectedExpert, setSelectedExpert, loading, handleExpertDirectoryClick } = useExpertManagement(query);

  return (
    <>
      {availableTabs.length > 0 && (
        <Paper sx={{ overflow: 'hidden', mb: 2 }}>
          <Box sx={{ overflowX: 'auto', width: '100%' }}>
            <PitchInboxTabs tabs={availableTabs} activeTab={activeTab} onTabChange={handleTabChange} />
          </Box>
          <Box sx={{ p: { xs: 0, sm: 1 } }}>
            <TabContent
              activeTab={activeTab}
              query={query}
              refetch={refetch}
              selectedExpert={selectedExpert}
              setSelectedExpert={setSelectedExpert}
              loading={loading}
              handleExpertDirectoryClick={handleExpertDirectoryClick}
            />
          </Box>
        </Paper>
      )}
      <QueryNotesTab queryID={query?.id} expert={selectedExpert} pitch={getPitchForExpert(query, selectedExpert?.id)} />
    </>
  );
};

PitchCard.propTypes = {
  query: PropTypes.object.isRequired,
  refetch: PropTypes.func,
};

export default PitchCard;
